export const BRAND_ADMIN_PPU = 'Brand Admin - PPU'
export const BRAND_ADMIN_CPA = 'Brand Admin'
export const GU_ADMIN = 'GU - Admin'
